import { validations } from "../../../../config/validations/validations";


export const rules: any = {
	username: (field?: string) => [
		validations.required.text(field),
		validations.username(field),
	],
	password: (field?: any) => [
		validations.required.text(field),
		validations.pattern.password(field),
	],
	otp: (field?: any) => [
		validations.required.text(field),
		validations.min.number(4,field),
	],
};